module.exports = __webpack_public_path__ + "img/ramji.d4b6c996.png";